import { Card, CardContent, CardHeader } from '@mui/material';

import { LinkList } from '@features/workspace/components/shared/link-list';

type QuickLinksCardProps = {
  header?: string;
  properties: Array<any>;
};

export function QuickLinksCard({ header, properties }: QuickLinksCardProps) {
  return (
    <>
      <Card>
        <CardHeader title={header} />
        <CardContent>
          <LinkList properties={properties} />
        </CardContent>
      </Card>
    </>
  );
}
